import alt from '../alt';
import modalAction from './modalAction';

class reportAction {
    constructor() {
        this.generateActions(
            'processing',
            'getReportSuccess',
            'getReportByRNSuccess',
            'getDetailSuccess',
            'updateSM',
            'updateEM',
            'updateUI',
            'updateCI',
            'updateRN',
            'warningMsg',
            'shouldListShow',
            'extendIncidentSuccess',
            'resolveIncidentSuccess',
            'addingRemarkSuccess',
            'removeIncidentSuccess',
            'closeListShow',
            'facility',
            'contractors',
            'isReportCreated',
        );
    }

    getReport(staffId, mcst, startYear, startMonth, endYear, endMonth) {
        if (sessionStorage.getItem('ui')) {
            let queryParam = "?staffId=" + staffId + "&mcst=" + mcst + "&startYear=" + startYear + "&startMonth=" + startMonth +
                "&endYear=" + endYear + "&endMonth=" + endMonth;
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/report' + queryParam, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.getReportSuccess(result);
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    getReportByRN(reportNo) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/report/' + reportNo, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.getReportByRNSuccess(result);
                    } else {
                        modalAction.modalContent({ title: "Warning", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    exportUnresolvedReport(staffId, mcst){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/report/unresolve', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "Unresolved_Incident_report.xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({
                staffId: staffId,
                mcst: mcst,
            }));
        }
        return true;
    }
    exportReport(staffId, mcst, startYear, startMonth, endYear, endMonth) {
        if (sessionStorage.getItem('ui')) {
            let naming;
            if (staffId == "" && mcst == "") {
                naming = "All";
            } else if (staffId == "") {
                naming = mcst;
            } else {
                naming = staffId;
            }
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/report', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "Incident_report_" + naming + "_" + startYear + "-" + (startMonth + 1) + ".xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({
                staffId: staffId,
                mcst: mcst,
                startYear: startYear,
                startMonth: startMonth,
                endYear: endYear,
                endMonth: endYear
            }));
        }
        return true;
    }
    downloadPDFfile(reportNo) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/report/pdf/' + reportNo, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/pdf' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = reportNo + "_incident_report.pdf";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    getDetailReport(reportId) {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/reportDetail/' + reportId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.getDetailSuccess(result);
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    extendIncident(reportId, fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/report/extend/' + reportId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.extendIncidentSuccess(result);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Deadline has been extended" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }
        return true;
    }

    resolveIncident(reportId, fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/report/resolve/' + reportId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {

                        this.resolveIncidentSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Incident status updated" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }
        return true;
    }

    addingRemark(reportId, fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/report/remark/' + reportId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.addingRemarkSuccess(result);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Remark has been added" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                        modalAction.modalClose(true);
                    }

                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }
        return true;
    }

    removeIncident(reportId, clientEmail, reason) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/report/status/' + reportId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.removeIncidentSuccess(result);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "The incident has been removed" });
                        modalAction.modalClose(true);
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({
                clientEmail: clientEmail,
                reason: reason
            }));
        }
        return true;
    }
    getFacility(mcst) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/condo/facility?mcst=' + mcst, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.facility(result);
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    getContractor(mcst){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/contractor/report?mcst=' + mcst, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.contractors(result);
                    } else {
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    createReport(fd){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/report' , true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        modalAction.modalContent({ title: "Successful", content: "Incident report created. Page will be refresh in 3 seconds" });
                        modalAction.modalClose(true);
                        this.isReportCreated(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }

        return true;
    }
}
export default alt.createActions(reportAction);


// WEBPACK FOOTER //
// ./app/actions/reportAction.js